import { CREATE, DETAIL } from '@/api/modules/settingField.api';

export default {
    create({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE({ payload }, successCallback, errorCallback);
    },
    detail({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DETAIL(successCallback, errorCallback);
    }
};
